import { Autocomplete, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import { useStyle } from "../style";
import axios from "axios";
import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import * as yup from 'yup';
import CustomTextField from "../../../../../components/utils/input/customTextField";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
const PaymentInfo = ({setData , data , setPostData , postData}) => {
  const classes = useStyle();
  const dispatch = useDispatch()
  const[supplierData,setSupplierData]=useState([])
  const [address , setAddress] = useState("")
  const [balance , setBalance] = useState(0)
  const [gstIn , setGstIn] = useState("")
  const [docNo, setDocNo] = useState('')
  const [selectedMode, setSelectedMode] = useState(null);
  const [modeValue , setModeValue] = useState(null)
  const getSupplierData = () => {
    axios.get(`/v1/supplier`)
    .then((res) => {
      setSupplierData(res.data)
    })
    .catch((err) => {console.log(err);dispatch(setSnackbar(true,'error',err.response.data.error))})
  }
  const handleChange =(e, name) => {
    console.log(e , name)
    const value = e.replace(/\D/g, "").trim()
    console.log(value,'vanthudu')
    if(name==='docDate' || name==='cheqDate'){
      setPoDetails((prevState) =>( {...prevState ,  [name] : dayjs(e).format() }))
    }else if(name === "amount"){
      setPoDetails((prevState) =>( {...prevState , amount : value }))
      console.log('first')
    }
    else{
      setPoDetails((prevState) =>( {...prevState , [name] :  e}))
      console.log('second')
    }
      
  }
const getPurchaseData = (id) => {
  axios.get(`/v1/payment/${id}`)
  .then((res) => {console.log(res); setData(res.data)})
  .catch((err) => {console.log(err);dispatch(setSnackbar(true , "error" ,err.response.data.errors[0].message ));setData([])})
}
  const handleSupplierChange = (event, value) => {
    getPurchaseData(value.id)
    const selectedSupplier = supplierData.find((supplier) => supplier.fullname === value?.fullname);
    console.log(selectedSupplier)
    setAddress(selectedSupplier ? (selectedSupplier.add1 + " " + selectedSupplier.add2 + "," + selectedSupplier.city_name + "-" + selectedSupplier.pincode + "-" + selectedSupplier.state_name + "-" + selectedSupplier.country_name) : ''); // Update this based on your actual data structure
    setGstIn(selectedSupplier ? selectedSupplier.gstin : "")
    setPoDetails((prevState) =>( {...prevState , supplierId:value}))  
    setBalance(selectedSupplier ? selectedSupplier.balance : 0)
  };
const [poDetails , setPoDetails] = useState({
  docDate:moment().format(),
  cheqDate:moment().format(),
  supplierId:null,
  cheqNo:"",
  Bank:"",
  utrNo:"",
  amount:"",
  mode:modeValue
})
const handleModeChange = (event) => {
  const selectedValue = event.target.value;
  setSelectedMode(selectedValue);

  // Perform additional actions based on the selected mode
  if (selectedValue === "Cash") {
    setModeValue(1)
  } else if (selectedValue === "Cheque") {
    setModeValue(2)
  } else if (selectedValue === "Upi") {
    setModeValue(3)
  }
};
  useEffect(() => {
    getSupplierData() // suplier name
    axios.get('/v1/payment/fetch/docno')
    .then(res=>setDocNo(res.data.Docno))
    .catch(err=> {
      console.log(err)
      dispatch(setSnackbar(true, 'error', err.response.data.error))
    })
  },[])
  useEffect(() => {
    if (poDetails.supplierId) {
      getPurchaseData(poDetails.supplierId.id);
    }
  }, [poDetails.supplierId]);
  useEffect(() => {
    setPostData((prevState ) => ({...prevState , date:moment(poDetails.docDate).format('YYYY/MM/DD') , supplierid:poDetails.supplierId !== null ? poDetails.supplierId.id : "",mode:modeValue,chequeno:poDetails.cheqNo,refno:poDetails.utrNo,chequedate:moment(poDetails.cheqDate).format('YYYY/MM/DD'),bank:poDetails.Bank,company_id: 1,amount:poDetails.amount}))
  },[poDetails,modeValue])
  console.log(postData)
console.log(data)
  return (
      <Grid container spacing={2} className="p-2 " >
        <Grid item lg={3} >
          <Autocomplete
            id="supplier"
            name="supplier"
            size="small"
            options={supplierData}
            getOptionLabel={(option) => option?.name}
            value={poDetails.supplierId}
            onChange={(e,value)=>handleSupplierChange(e,value)}
            disableClearable
            isOptionEqualToValue={(option, value) =>
              option.name === value.name
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Supplier Name"
                autoComplete="off"
                // required
              />
            )}
            />
          <TextField size="small" label='Address'  multiline rows={3.3} fullWidth sx={{marginBlock:1.5}}  InputProps={{ readOnly: true }} value={address}/>
          <TextField size="small" label='GSTIN' fullWidth  value={gstIn} InputProps={{ readOnly: true }}/>
        </Grid>
        <Grid item lg={3}>
        <TextField size="small" label='Bill No' fullWidth value={docNo} InputProps={{ readOnly: true }}/>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker onChange={(e)=>handleChange(e,'docDate')}  value={dayjs(poDetails.docDate)} label="Bill Date" slotProps={{
                    textField: {
                      size: "small",
                    },
                  }}
                  sx={{width: '100%',marginBlock:1.5}}
            />
          </LocalizationProvider>
          <Typography variant="body1">Mode</Typography>
          <FormControl sx={{ display: "flex" }}>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        name="mode"
        id="mode"
        sx={{ flexDirection: "row", display: "flex" }}
        value={selectedMode}
        onChange={handleModeChange}
      >
        <FormControlLabel
          value="Cash"
          control={<Radio size="small" />}
          label="Cash"
        />
        <FormControlLabel
          value="Cheque"
          control={<Radio size="small" />}
          label="Cheque/DD"
        />
        <FormControlLabel value="Upi" control={<Radio size="small" />} label="UPI" />
      </RadioGroup>
    </FormControl>
        </Grid>
        <Grid item lg={3} >
          <TextField size="small" label='Cheque No' fullWidth  onChange={(e)=>handleChange(e.target.value,'cheqNo')} sx={{marginBlockEnd:1 , display: selectedMode === 'Cheque' ? 'block' : 'none' }}/>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker onChange={(e)=>handleChange(e,'cheqDate')} value={dayjs(poDetails.cheqDate)} label="Cheque Date" slotProps={{
                    textField: {
                      size: "small",
                    },
                  }}
                  sx={{width: '100%',marginBlock:1.5 , display: selectedMode === 'Cheque' ? 'block' : 'none'}}
            />
          </LocalizationProvider>

          <TextField size="small" label='Bank' fullWidth sx={{marginBlockEnd:1,  display: selectedMode === 'Cash' ? 'none' : 'block'}}  onChange={(e)=>handleChange(e.target.value,'Bank')} />
          <TextField size="small" label='UTR NO' fullWidth sx={{marginBlockEnd:1 , display: selectedMode === 'Upi' ? 'block' : 'none'}}  onChange={(e)=>handleChange(e.target.value,'utrNo')}/>
          <TextField size="small" label='Amount'value={poDetails.amount}  fullWidth sx={{marginBlockEnd:1}}  onChange={(e)=> handleChange(e.target.value,'amount')} />
        </Grid>
        <Grid item lg={3}>
        <Typography textAlign="center" variant="h6" sx={{backgroundColor:'#83A2FF',}}>Balance</Typography>
            <Typography textAlign='right' variant="h5" mt={1} sx={{fontWeight:600,}} >{balance}</Typography>
        </Grid>
      </Grid>
  );
};

export default memo(PaymentInfo);
